import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function BackButton({ to, label = "Back" }) {
    const navigate = useNavigate();

    return (
        <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => navigate(to)}
            className="group -ml-2 w-fit gap-2 rounded-md px-3 py-1.5 text-muted-foreground hover:bg-primary/10 hover:text-primary"
            aria-label={label}
            data-testid="page-back-button"
        >
            <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-0.5" strokeWidth={1.8} />
            {label}
        </Button>
    );
}
